import React  from "react"; 
import { makeStyles } from "@material-ui/core/styles";
import {
    Button,
    Dialog, 
    DialogContent,
    DialogTitle, 
  } from "@material-ui/core";  

const useStyles = makeStyles((theme) => ({
  item: {
    fontFamily: 'Poppins',
    fontSize: '12.81px',
    fontWeight: 500,
    lineHeight: '19.22px',
    textAlign: 'left' ,
    color: 'rgba(181, 181, 195, 1)',
    padding: '3px'
  }
}));

function ModalInfo(props) {
  const classes = useStyles();
  return (
    <Dialog
      //   fullWidth
      maxWidth={"xs"}
      open={props.open}
      onClose={() => props.close()}
    >
      {/* <DialogTitle  className={classes.titer}>
                {props.title} 
        </DialogTitle> */}
        <DialogContent>
          {props.data.map((goods, index) => (
            <li className={classes.item}>{goods}</li>
          ))}
        </DialogContent>
    </Dialog>
  )
}

export default ModalInfo;